/**
 * return k-text-w-[name]
 * @param name
 */
export default (name?: string) => {
  if(!name) {
    return ''
  }
  return ['k-text-w', name].join('-')
}
